export default __webpack_public_path__ + "static/atlas_icon-a2c0de481d98dd318f21fc2a6a501a8d.png";